import type { IconName } from '@/shared/ui/icon'

// Метка «почему сущность в выдаче» (docs/design/screens/search.md): совпадение в
// названии (title/name) самоочевидно (метки нет), в описании/треде/теге — поясняем.
export function matchedInLabel(matchedIn: string): { label: string; icon?: IconName } | null {
  if (matchedIn === 'thread') return { label: 'тред', icon: 'reply' }
  if (matchedIn === 'description') return { label: 'в описании' }
  if (matchedIn === 'tag') return { label: 'по тегу', icon: 'flag' }
  return null
}
